module.exports = __webpack_public_path__ + "media/student_contributors/10RyanSmith-aed46f5b.png";